import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'dsio-tenant-registration-client';
  sidebarTitle = 'Registration';
  sidebarSummary = 'Guided signup is in progress. Continue in the main panel.';
  isLocal = environment.env === 'local';
  dryRunEnabled = Boolean(environment.disableTenantApi);

  constructor(private readonly router: Router) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const path = event.urlAfterRedirects;
        if (path.startsWith('/atlas/checkout/success')) {
          this.sidebarTitle = 'Checkout complete';
          this.sidebarSummary = 'Subscription activated. Continue setup from the main panel.';
        } else if (path.startsWith('/atlas/checkout/cancel')) {
          this.sidebarTitle = 'Checkout canceled';
          this.sidebarSummary = 'No charge applied. Return to select a plan when ready.';
        } else if (path.startsWith('/activate-account')) {
          this.sidebarTitle = 'Account activation';
          this.sidebarSummary = 'Email verification is in progress. Continue in the main panel.';
        } else if (path.startsWith('/atlas')) {
          this.sidebarTitle = 'Atlas signup';
          this.sidebarSummary = 'Register your tenant and choose a plan.';
        } else if (path.startsWith('/onboard-mkpl')) {
          this.sidebarTitle = 'Marketplace onboarding';
          this.sidebarSummary = 'Confirm tenant details to finish marketplace setup.';
        } else if (path.startsWith('/thanks')) {
          this.sidebarTitle = 'Confirmation';
          this.sidebarSummary = 'Check your email for the verification link before continuing.';
        } else {
          this.sidebarTitle = 'Registration';
          this.sidebarSummary = 'Guided signup is in progress. Continue in the main panel.';
        }
      });
  }

  setDryRun(enabled: boolean): void {
    this.dryRunEnabled = enabled;
    environment.disableTenantApi = enabled;
  }
}
